export const GA_GENERAL_CATEGORY = 'General';

export const GA_GENERAL_EVENTS = {
  POPUP_OPEN: 'POPUP_OPEN',
};

export const GA_GENERAL_POPUPS_SOURCES = {
  URL: 'URL',
  DASHBOARD: 'DASHBOARD',
};

export const GA_GENERAL_POPUPS_EVENTS = {
  PHONE_NUBMER_UPDATE: 'PHONE_NUBMER_UPDATE',
  PHONE_NUBMER_UPDATE_SUCCESS: 'PHONE_NUBMER_UPDATE_SUCCESS',
  PHONE_NUMBER_UPDATE_DUPLICATION_FAILURE: 'PHONE_NUMBER_UPDATE_DUPLICATION_FAILURE',
};

export const GA_QUESTIONNAIRE_CATEGORY = 'Questionnaire';

export const GA_QUESTIONNAIRE_EVENTS = {
  QUESTIONNAIRE_STARTED: 'QUESTIONNAIRE_STARTED',
  QUESTIONNAIRE_STARTED_INTAKE: 'QUESTIONNAIRE_STARTED_INTAKE',
  QUICK_SIGNUP_POPUP_VIEW: 'QUICK_SIGNUP_POPUP_VIEW',
  QUICK_SIGNUP_POPUP_VIEW_INTAKE: 'QUICK_SIGNUP_POPUP_VIEW_INTAKE',
  QUICK_SIGNUP_SUCCESS: 'QUICK_SIGNUP_SUCCESS',
  QUICK_SIGNUP_SUCCESS_INTAKE: 'QUICK_SIGNUP_SUCCESS_INTAKE',
  QUESTIONNAIRE_ENDED: 'QUESTIONNAIRE_ENDED',
};

export const GA_INTAKE_CATEGORY = 'Intake';

export const GA_INTAKE_EVENTS = {
  INTAKE_BOT_VIEW: 'INTAKE_BOT_VIEW',
  INTAKE_PAGE_VIEW: 'INTAKE_PAGE_VIEW',
  INTAKE_QUESTION_ANSWERED: 'INTAKE_QUESTION_ANSWERED',
  INTAKE_MEDICAL_DONE: 'INTAKE_MEDICAL_DONE',
  INTAKE_ABOUT_DONE: 'INTAKE_ABOUT_DONE',
};

export const GA_SIGNUP_CATEGORY = 'Signup';
export const GA_SIGNUP = {
  VISITOR_LANDED: 'SIGNUP_VISITOR_LANDED',
  SIGNUP_VIA_FILE_UPLOAD_IS_CHOSEN: 'SIGNUP_VIA_FILE_UPLOAD_IS_CHOSEN',
  QUESTIONNAIRE_FIRST_QUESTION_VIEWED: 'SIGNUP_QUESTIONNAIRE_FIRST_QUESTION_VIEWED',
  AFTER_QUESTIONNAIRE_SIGNUP_FORM_VIEWED: 'AFTER_QUESTIONNAIRE_SIGNUP_FORM_VIEWED',
  BEFORE_FILE_UPLOAD_SIGNUP_FORM_VIEWED: 'BEFORE_FILE_UPLOAD_SIGNUP_FORM_VIEWED',
  PHONE_STEP_VIEWED: 'SIGNUP_PHONE_STEP_VIEWED',
  PHONE_STEP_SUBMIT: 'SIGNUP_PHONE_STEP_SUBMIT',
  PHONE_ADDED: 'SIGNUP_PHONE_ADDED',
  NAME_ADDED: 'SIGNUP_NAME_ADDED',
  LOCATION_STEP_VIEWED: 'SIGNUP_LOCATION_STEP_VIEWED',
  LOCATION_STEP_SUBMIT: 'SIGNUP_LOCATION_STEP_SUBMIT',
  LOCATION_ADDED: 'SIGNUP_LOCATION_ADDED',
};

export const GA_LOGIN_CATEGORY = 'Login';

export const GA_LOGIN_EVENTS = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_SUCCESS_TOKEN: 'LOGIN_SUCCESS_TOKEN',
};

export const GA_CHAT_EVENTS = {
  PROFILE_CHAT_OPEN: 'PROFILE_CHAT_OPEN',
  PROFILE_CHAT_CLOSE: 'PROFILE_CHAT_CLOSE',
  PROFILE_CHAT_STARTED: 'PROFILE_CHAT_STARTED',
  PROFILE_CHAT_USER_UPDATE_SCAN: 'PROFILE_CHAT_USER_UPDATE_SCAN',
  PROFILE_CHAT_USER_CLICKED_ACTION_PANEL: 'PROFILE_CHAT_USER_CLICKED_ACTION_PANEL',
  PROFILE_CHAT_USER_UPDATE_SCORING: 'PROFILE_CHAT_USER_UPDATE_SCORING',
  PROFILE_CHAT_USER_SEND_MESSAGE_TO_CHAT: 'PROFILE_CHAT_USER_SEND_MESSAGE_TO_CHAT',
  PROFILE_CHAT_VIEW_BY_USER: 'PROFILE_CHAT_VIEW_BY_USER',
};

export const GA_UPLOAD_CHAT_EVENTS = {
  UPLOAD_CHAT_OPEN: 'UPLOAD_CHAT_OPEN',
  UPLOAD_CHAT_CLOSE: 'UPLOAD_CHAT_CLOSE',
  UPLOAD_CHAT_USER_UPDATE_SCORING: 'UPLOAD_CHAT_USER_UPDATE_SCORING',
  UPLOAD_CHAT_USER_SEND_MESSAGE_TO_CHAT: 'UPLOAD_CHAT_USER_SEND_MESSAGE_TO_CHAT',
  UPLOAD_CHAT_VIEW_BY_USER: 'UPLOAD_CHAT_VIEW_BY_USER',
};

export const GA_UPLOAD_EXPLAIN_CHAT_EVENTS = {
  UPLOAD_EXPLAIN_CHAT_OPEN: 'UPLOAD_EXPLAIN_CHAT_OPEN',
  UPLOAD_EXPLAIN_CHAT_CLOSE: 'UPLOAD_EXPLAIN_CHAT_CLOSE',
  UPLOAD_EXPLAIN_CHAT_USER_UPDATE_SCORING: 'UPLOAD_EXPLAIN_CHAT_USER_UPDATE_SCORING',
  UPLOAD_EXPLAIN_CHAT_USER_SEND_MESSAGE_TO_CHAT: 'UPLOAD_EXPLAIN_CHAT_USER_SEND_MESSAGE_TO_CHAT',
  UPLOAD_EXPLAIN_CHAT_VIEW_BY_USER: 'UPLOAD_EXPLAIN_CHAT_VIEW_BY_USER',
};

export const GA_NBA_CATEGORY = 'NBA';

export const GA_NBA_EVENTS = {
  MILESTONE_TAB_CLICKED: 'nba_milestone_tab_clicked',
  STEP_TAB_CLICKED: 'nba_step_tab_clicked',
  TREATMENT_TYPE_SELECTED: 'nba_treatment_type_selected',
  CTA_CLICKED: 'nba_cta_clicked',
  STEP_NAVIGATOR_CLICKED: 'nba_step_navigator_clicked',
};
export const GA_MATCHED_TRIAL_CATEGORY = 'MATCHED_TRIAL';
export const GA_MATCHED_TRIAL_EVENTS = {
  // trial view by a matched user (not hcp caregiver)
  TRIAL_VIEWED: 'MATCHED_TRIAL_VIEWED',
  // clicked by matched user
  CONTACT_INTERESTED_CLICKED: 'MATCHED_TRIAL_CONTACT_INTERESTED_CLICKED',
  TRIAL_SEE_CONTACT_DETAIL: 'TRIAL_SEE_CONTACT_DETAIL',
  TRIAL_CONTACT_SITE_SUBMIT_FORM: 'TRIAL_CONTACT_SITE_SUBMIT_FORM',
  TRIAL_REQUEST_INFO_CLICKED: 'TRIAL_REQUEST_INFO_CLICKED',
};

export const GA_MATCHED_TREATMENT_CATEGORY = 'MATCHED_TREATMENT';
export const GA_MATCHED_TREATMENT_EVENTS = {
  // treatment view by a matched user (not hcp caregiver)
  TREATMENT_VIEWED: 'MATCHED_TREATMENT_VIEWED',
};
